"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _context;

/**
 * @file virtualObjects.ts
 * Created by wangning25 on 2021/10/05.
 */

/**
 * 说明：
 * 在基于Chrome/48及以下的Android Browser/WebView（如：OPPO R9m Android 5.1 Chrome/43.0.2357.121）
 * 使用了Proxy垫片（https://www.npmjs.com/package/proxy-polyfill），
 * 正如垫片的README所述（This means that the properties you want to proxy must be known at creation time）。
 * 故在此声明被代理的虚拟对象的属性，配合垫片跑通。
 */
var virtualObjects = {
  common: ['openFansClubJoinPanel', 'createRoom', 'storageGetItem', 'openGiftPanel', 'openReserveInfoGoodsList', 'selectionchange', 'openWebview', 'toast', 'login', 'atTA', 'openAnchorLevelPanel', 'confirm', 'openFansClubTaskPanel', 'openReportLivePanel', 'subscribeList', 'closeWebview', 'exitFans', 'getTheme', 'uploadImg', 'enterRoom', 'getRoomInfo', 'storageSetItem', 'storageGetItem', 'storageRemoveItem', 'storageClear', 'imSettings', 'setClipboardData', 'getClipboardData', 'openCommentPanel', 'beforeEnterRoom', 'canDrag', 'getGroupChatInfo', 'getUserInfo', 'openAskAnswer', 'openVoice', 'preRenderFinish', 'openHomePage', 'openEditText', 'router', 'follow', 'unfollow', 'showModal', 'openYYPayPanel', 'showUserInfo', 'photoChooseAndUpload', 'refreshRoom', 'openYYPayPanel', 'showNotificationPop', 'getNotificationPermissionStatus', 'openGoodsListPanel', 'tel', 'openLiveClassification', 'openLiveTag', 'openNotConsultingHostVoiceConsultingPrice', 'setShareInfo', 'seriesLessonChapterUpdate', 'openNotConsultingHostVoicePicture', 'share', 'getNetworkInfo', 'executeScheme', 'getParallelResponseByKeys', 'openCouponListPanel', 'sendLog', 'getCommonParams', 'getNAPerfData', 'taskOfLeftWatchTime'],
  consult: ['saveHealthCategory', 'openConsultingHostTextConsultingPrice', 'openConsultingHostVoiceConsultingPrice', 'openConsultPanel', 'answerCaseClick'],
  eshop: ['screenShot', 'shoppingCart', 'completeRedenvelopeRain', 'getActivityInfo'],
  match: ['applyLine', 'quitSingleGroup'],
  voice: ['isHost', 'closeSmallWindow', 'requestRecordAudioPermission', 'createVoiceRoom', 'alterBlackboard', 'previewImages', 'editRoomTitle', 'createBlackboard', 'checkUserRealNameAuthentication', 'accountRealNameGuide', 'exitVoiceRoom', 'chooseCover']
};
(0, _forEach.default)(_context = (0, _keys.default)(virtualObjects)).call(_context, function (key) {
  var _context2;

  virtualObjects[key] = (0, _reduce.default)(_context2 = virtualObjects[key]).call(_context2, function (pre, cur) {
    pre[cur] = function () {
      window.console.log('virtual fn');
    };

    return pre;
  }, {});
});
var _default = virtualObjects; // list生成：
// 1. 访问： https://live.baidu-int.com/fe/scheme/list/livecenter?app=livecenter
// 2. console 执行如下代码
// Array.from(document.querySelector('[aria-hidden="false"]').querySelectorAll('.scheme-name')).map(item => {
//     return item.textContent.replace(/.*\/(\w+)$/, '$1');
// });

exports.default = _default;